import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";

import { workScheduleReportOnLoad } from "features/planner/report/report.actions";
import { WORK_SCHEDULE_REPORT_TYPE } from "features/planner/report/report.constants";
import WorkScheduleYearReport from "features/planner/report/workSchedule/components/year/WorkScheduleYearReport";
import WorkScheduleMonthReport from "features/planner/report/workSchedule/components/month/WorkScheduleMonthReport";

class WorkScheduleReport extends PureComponent {
  render() {
    const { report, reportType, dates } = this.props;

    return (
      <>
        {reportType === WORK_SCHEDULE_REPORT_TYPE.MONTH && (
          <WorkScheduleMonthReport dates={dates} report={report} />
        )}
        {reportType === WORK_SCHEDULE_REPORT_TYPE.YEAR && (
          <WorkScheduleYearReport dates={dates} report={report} />
        )}
      </>
    );
  }
}

export default compose(
  connect(null, {
    dispatchOnLoad: workScheduleReportOnLoad,
  }),
)(WorkScheduleReport);
